<template>
    <div class="card-arrow" :class="props.direction" @click="emitChange">&#x2303;</div>
</template>

<script lang="ts" setup>

interface Props {
    direction: string;
}
const props = defineProps<Props>();
const emit = defineEmits(['scroll-left', 'scroll-right']);

const emitChange = (): void => {
    if (props.direction === 'left')
        emit('scroll-left');
    else if (props.direction === 'right') 
        emit('scroll-right');
};
</script>

<style scoped>
.card-arrow {
    display: inline-block;
    font-size: 48px;
    margin-top: 16px;
    color: #6a998f; /* Soft green color for arrows */
    cursor: pointer;
    transition: color 0.3s ease;
}

.card-arrow:hover {
    color: #90b7a7; /* Softer green on hover */
}

.left {
    transform: scale(2, 4) rotate(-90deg);
}

.right {
    transform: scale(2, 4) rotate(90deg);
}
</style>
